import React from "react";

const Stats = ({ data }) => {

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-2 sm:gap-4 mb-4 sm:mb-8">
      <div className="bg-gray-700 p-2 sm:p-4 rounded-lg shadow text-center">
        <i className="fas fa-users text-pink-500 text-lg sm:text-2xl mb-1 sm:mb-2"></i>
        <p className="text-sm sm:text-lg">Total Traders: {data.traders}</p>
      </div>
      <div className="bg-gray-700 p-2 sm:p-4 rounded-lg shadow text-center">
        <i className="fas fa-chart-bar text-pink-500 text-lg sm:text-2xl mb-1 sm:mb-2"></i>
        <p className="text-sm sm:text-lg">
          Total Volume: {(Number(data.totalSats) / Math.pow(10, 8)).toFixed(3)} BTC
        </p>
      </div>
      <div className="bg-gray-700 p-2 sm:p-4 rounded-lg shadow text-center">
        <i className="fas fa-chart-line text-pink-500 text-lg sm:text-2xl mb-1 sm:mb-2"></i>
        <p className="text-sm sm:text-lg">
          Avg Profit: {data.profit}%
        </p>
      </div>
    </div>
  );
};

export default Stats;
